/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationdeleteduser2Inputs */

const en_moderationdeleteduser2 = /** @type {(inputs: Moderationdeleteduser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted user`)
};

const de_moderationdeleteduser2 = /** @type {(inputs: Moderationdeleteduser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöschter Nutzer`)
};

/**
* | output |
* | --- |
* | "Deleted user" |
*
* @param {Moderationdeleteduser2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationdeleteduser2 = /** @type {((inputs?: Moderationdeleteduser2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationdeleteduser2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationdeleteduser2(inputs)
	return de_moderationdeleteduser2(inputs)
});
export { moderationdeleteduser2 as "moderationDeletedUser" }